import { Empty, Spin, Flex, Button } from "antd";

import PlusIcon from "@/icons/PlusIcon";

import AttachedObjectsTable from "@/components/tables/AttachedObjectsTable";

const ObjectsTab = ({
  data,
  isAdmins,
  pending,
  readOnly = false,
  handleAddNew,
  handleDelete,
}) => {
  return pending ? (
    <div className="spin" style={{ height: 100 }}>
      <Spin size="large" />
    </div>
  ) : !!data.length ? (
    <Flex vertical gap={15}>
      <Flex justify="flex-end" gap={15} align="center">
        {!readOnly && (
          <Button
            type="primary"
            icon={<PlusIcon />}
            onClick={handleAddNew}
          ></Button>
        )}
      </Flex>

      <AttachedObjectsTable
        data={data}
        loading={pending}
        isAdmins={isAdmins}
        onDeleteItem={handleDelete}
      />
    </Flex>
  ) : (
    <>
      <Flex justify="flex-end" gap={15} align="center">
        {!readOnly && (
          <Button
            type="primary"
            icon={<PlusIcon />}
            onClick={handleAddNew}
          ></Button>
        )}
      </Flex>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    </>
  );
};

export default ObjectsTab;
